import { render } from "./confirm-your-email-modal.vue?vue&type=template&id=7590f5b8&scoped=true"
import script from "./confirm-your-email-modal.vue?vue&type=script&lang=js"
export * from "./confirm-your-email-modal.vue?vue&type=script&lang=js"

import "./confirm-your-email-modal.vue?vue&type=style&index=0&id=7590f5b8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7590f5b8"]])

export default __exports__